var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import * as BVConstants from "../../config/BVConstants";
import * as ExcelJS from 'exceljs';
import { formatDateForExcel, isEmptyObject } from '../../utils/commonUtil';
import { Button } from 'antd';
import { getPrjEEMasterProducts } from '../../services/projectService';
import commonService from "../../services/CommonService";
import { UserActivity } from "../../config/BVConstants";
import { useSelector } from "react-redux";
const GenerateExcelReport = (Props) => {
    const [lstRiskReason, setLstRiskReason] = useState([]);
    const [lstMasterProduct, setLstMasterProduct] = useState([]);
    const [mpCount1, setmpCount1] = useState(0);
    const [mapRiskCommentsWO, setMapRiskCommentsWO] = useState(new Map());
    const applicationData = useSelector((state) => state.applicationData);
    /*
        const lstDocuments = [
          {
            objLuDocumentCategory : {
                intId : 123,
                strLongDesc: 'First Doc Category'
            },
            objDocumentType : {
              strLongDesc: 'First Document Type'
            },
            boolIsGeneralDoc : false,
            objLuCountry : {
              intId : 12,
              strLongDesc : 'India'
            },
            strServiceTypes : ''
          },
          {
            objLuDocumentCategory : {
                intId : 124,
                strLongDesc: 'Second Doc Category'
            },
            objDocumentType : {
              strLongDesc: 'Second Document Type'
            },
            boolIsGeneralDoc : true,
            objLuCountry : {
              intId : 13,
              strLongDesc : 'Japan'
            },
            strServiceTypes : 'Service5'
          }
        ];*/
    //Props.objMaster.lstDocuments = lstDocuments;
    useEffect(() => {
        var _a, _b, _c, _d;
        if (((_b = (_a = Props.objMaster) === null || _a === void 0 ? void 0 : _a.lstWorkOrder) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            (_d = (_c = Props.objMaster) === null || _c === void 0 ? void 0 : _c.lstWorkOrder) === null || _d === void 0 ? void 0 : _d.forEach((workOrder) => {
                if ((workOrder === null || workOrder === void 0 ? void 0 : workOrder.intRiskStatus) !== 1) {
                    getLstRiskReason(workOrder === null || workOrder === void 0 ? void 0 : workOrder.strWorkOrderId);
                }
            });
        }
        //
    }, []);
    useEffect(() => {
        var _a, _b;
        if ((_a = Props === null || Props === void 0 ? void 0 : Props.objMaster) === null || _a === void 0 ? void 0 : _a.boolIsMultipleProdReq) {
            getPrjEEMasterProducts((_b = Props === null || Props === void 0 ? void 0 : Props.objMaster) === null || _b === void 0 ? void 0 : _b.strProjectId).then((response) => {
                setLstMasterProduct(response);
                setmpCount1(response.length);
            });
        }
    }, []);
    //useEffect(() => {
    function getLstRiskReason(workOrderId) {
        try {
            const responseData = getLstRiskReason(JSON.stringify(workOrderId));
            //
            const appendedComments = responseData === null || responseData === void 0 ? void 0 : responseData.map((data) => {
                return data === null || data === void 0 ? void 0 : data.strComments;
            });
            mapRiskCommentsWO.set(workOrderId, appendedComments === null || appendedComments === void 0 ? void 0 : appendedComments.join(" "));
            //newData?.push({workOrderId : appendedComments?.join(" ")});
            //
            //setListRiskCommentsWO(newData);
            setMapRiskCommentsWO(mapRiskCommentsWO);
        }
        catch (error) {
            console.error(error);
        }
    }
    //}, []);
    function applyStylesToHeader(rowNo, n, colorValue, worksheet) {
        const row = worksheet.getRow(rowNo);
        row.font = { bold: true };
        row.alignment = { vertical: 'middle', horizontal: 'center' };
        for (let i = 1; i <= 11; i++) {
            row.getCell(i).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: colorValue },
            };
        }
    }
    function getNextRow(startRow, mpCount, currRow) {
        let actualCellNo = 3 + (currRow - 1) * mpCount;
        return actualCellNo;
    }
    const generateExcel = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4;
        if (isEmptyObject(Props.objMaster)) {
            return;
        }
        //let lstMasterProduct:any = [];
        //let mpCount=0;
        //let intMultiProdItemsCount = 3;
        /*
        let lstMasterProduct = [
          {
            strProductNameEN : 'Product 1',
            strPrimaryModel : 'Product Model 1',
            objBrandName : {
              strLongDesc : 'Brand Name 1'
            }
          },
          {
            strProductNameEN : 'Product 2',
            strPrimaryModel : 'Product Model 2',
            objBrandName : {
              strLongDesc : 'Brand Name 2'
            }
          },
          {
            strProductNameEN : 'Product 3',
            strPrimaryModel : 'Product Model 3',
            objBrandName : {
              strLongDesc : 'Brand Name 3'
            }
          }
        ];*/
        //let mpCount1=0;
        //let mpCount1=lstMasterProduct?.length;
        //if(Props?.objMaster?.boolIsMultipleProdReq) {
        //lstMasterProduct = EECPCommonHelper.getArtifactProductLst(objMaster.getStrProjectId());
        //intMultiProdItemsCount= lstMasterProduct.size();
        //mpCount=intMultiProdItemsCount-1;
        //}
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Project Details');
        const isRenewal = (_a = Props.objMaster) === null || _a === void 0 ? void 0 : _a.boolRenewalArtifact;
        const projectId = (_b = Props.objMaster) === null || _b === void 0 ? void 0 : _b.strProjectId;
        const columns = [
            { header: 'Name1', key: 'name1', width: 25.27 }, // Set the width of column A to 25.27
            { header: 'Name2', key: 'name2', width: 10 },
            { header: 'Name3', key: 'name3', width: 10 },
            { header: 'Name4', key: 'name4', width: 10 },
            { header: 'Name5', key: 'name5', width: 10 },
            { header: 'Name6', key: 'name6', width: 10 },
            { header: 'Name7', key: 'name7', width: 10 },
            { header: 'Name8', key: 'name8', width: isRenewal ? 10 : 22.27 },
            { header: 'Name9', key: 'name9', width: isRenewal ? 22.27 : 10 },
            { header: 'Name10', key: 'name10', width: 10 },
            { header: 'Name11', key: 'name11', width: 10 },
            { header: 'Name12', key: 'Name12', width: 10 },
            { header: 'Name13', key: 'name13', width: 10 },
            { header: 'Name14', key: 'name14', width: 10 },
            { header: 'Name15', key: 'name15', width: 10 },
            { header: 'Name16', key: 'name16', width: isRenewal ? 10 : 26.73 },
            isRenewal && { header: 'Name17', key: 'name17', width: 10 },
            isRenewal && { header: 'Name18', key: 'name18', width: isRenewal ? 26.73 : 10 },
        ];
        worksheet.columns = columns;
        worksheet.getCell('A1').value = (_e = (_d = (_c = Props.objMaster) === null || _c === void 0 ? void 0 : _c.objClientMaster) === null || _d === void 0 ? void 0 : _d.objLuCompany) === null || _e === void 0 ? void 0 : _e.strLongDesc;
        worksheet.getCell('A2').value = BVConstants.ProjectDetailsExcelTemplate.Project_Info;
        worksheet.getCell('A3').value = BVConstants.ProjectDetailsExcelTemplate.Project_No;
        worksheet.getCell('B3').value = (_f = Props.objMaster) === null || _f === void 0 ? void 0 : _f.strProjectId;
        let psRow = 4;
        let rsRow = 5;
        let prRow = 6;
        let serviceHeaderRow = 8;
        if (mpCount1 != 0 && !isRenewal) {
            psRow = getNextRow(3, mpCount1, 2);
            rsRow = getNextRow(3, mpCount1, 3);
            prRow = getNextRow(3, mpCount1, 4);
            serviceHeaderRow = 8 + 3 * Math.max(0, mpCount1 - 1);
        }
        worksheet.getCell(`A${psRow}`).value = BVConstants.ProjectDetailsExcelTemplate.Project_Status;
        worksheet.getCell(`B${psRow}`).value = (_h = (_g = Props.objMaster) === null || _g === void 0 ? void 0 : _g.objProjectStatus) === null || _h === void 0 ? void 0 : _h.strLongDesc;
        worksheet.getCell(`A${rsRow}`).value = 'Risk Status:';
        worksheet.getCell(`B${rsRow}`).value = ((_j = Props.objMaster) === null || _j === void 0 ? void 0 : _j.riskStatusId) === 1 ? "Project on Schedule" : "Project on Risk";
        worksheet.getCell(`A${prRow}`).value = 'Project Report Issue Date:';
        worksheet.getCell(`B${prRow}`).value = new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
        ;
        worksheet.getCell(`A${serviceHeaderRow}`).value = BVConstants.ProjectDetailsExcelTemplate.Service_Info;
        if (isRenewal) {
            worksheet.getCell('I3').value = 'Product Name:';
            worksheet.getCell('J3').value = (_k = Props.objMaster) === null || _k === void 0 ? void 0 : _k.strProductNameEN;
            worksheet.getCell(`I4`).value = 'Product Model:';
            worksheet.getCell('J4').value = (_l = Props.objMaster) === null || _l === void 0 ? void 0 : _l.strPrimaryModel;
            worksheet.getCell(`I5`).value = 'Brand/OEM:';
            worksheet.getCell('J5').value = (_o = (_m = Props.objMaster) === null || _m === void 0 ? void 0 : _m.objBrandName) === null || _o === void 0 ? void 0 : _o.strLongDesc;
            worksheet.getCell(`I6`).value = 'Document Completion:';
            worksheet.getCell(`J6`).value = (_p = Props.objMaster) === null || _p === void 0 ? void 0 : _p.dbDocumentCompletionPer;
            worksheet.mergeCells('A1:R1');
            worksheet.mergeCells('A2:R2');
            worksheet.mergeCells('B3:H3');
            worksheet.mergeCells('J3:R3');
            worksheet.mergeCells('B4:H4');
            worksheet.mergeCells('J4:R4');
            worksheet.mergeCells('B5:H5');
            worksheet.mergeCells('J5:R5');
            worksheet.mergeCells('B6:H6');
            worksheet.mergeCells('J6:R6');
            worksheet.mergeCells('A8:R8');
        }
        else {
            worksheet.getCell('H3').value = 'Product Name:';
            //worksheet.getCell('I3').value = Props.objMaster?.strProductNameEN;
            if (mpCount1 != 0) {
                worksheet.getCell(`H${getNextRow(3, mpCount1, 2)}`).value = 'Product Model:';
                worksheet.getCell(`H${getNextRow(3, mpCount1, 3)}`).value = 'Brand/OEM:';
                worksheet.getCell(`H${getNextRow(3, mpCount1, 4)}`).value = 'Document Completion:';
                worksheet.getCell(`I${getNextRow(3, mpCount1, 4)}`).value = (_q = Props.objMaster) === null || _q === void 0 ? void 0 : _q.dbDocumentCompletionPer;
                for (let i = 0; i < mpCount1; i++) {
                    worksheet.getCell(`I${3 + i}`).value = (_r = lstMasterProduct[i]) === null || _r === void 0 ? void 0 : _r.strProductNameEN;
                    worksheet.getCell(`I${getNextRow(3, mpCount1, 2) + i}`).value = (_s = lstMasterProduct[i]) === null || _s === void 0 ? void 0 : _s.strPrimaryModel;
                    worksheet.getCell(`I${getNextRow(3, mpCount1, 3) + i}`).value = (_u = (_t = lstMasterProduct[i]) === null || _t === void 0 ? void 0 : _t.objBrandName) === null || _u === void 0 ? void 0 : _u.strLongDesc;
                }
            }
            else {
                worksheet.getCell('H4').value = 'Product Model:';
                worksheet.getCell('H5').value = 'Brand/OEM:';
                worksheet.getCell('I3').value = (_v = Props.objMaster) === null || _v === void 0 ? void 0 : _v.strProductNameEN;
                worksheet.getCell('I4').value = (_w = Props.objMaster) === null || _w === void 0 ? void 0 : _w.strPrimaryModel;
                worksheet.getCell('I5').value = (_y = (_x = Props.objMaster) === null || _x === void 0 ? void 0 : _x.objBrandName) === null || _y === void 0 ? void 0 : _y.strLongDesc;
                worksheet.getCell('H6').value = 'Document Completion:';
                worksheet.getCell('I6').value = (_z = Props.objMaster) === null || _z === void 0 ? void 0 : _z.dbDocumentCompletionPer;
            }
            //
            //merge columns
            worksheet.mergeCells('A1:P1');
            worksheet.mergeCells('A2:P2');
            if (mpCount1 != 0) {
                for (let i = 0; i < 3 * mpCount1 + 1; i++) {
                    //worksheet.mergeCells(`B${3+i}:G${3+i}`);
                    worksheet.mergeCells(`I${3 + i}:P${3 + i}`);
                    const rowData = worksheet.getRow(i + 3);
                    rowData.font = { bold: true };
                }
            }
            else {
                worksheet.mergeCells('B3:G3');
                worksheet.mergeCells('B4:G4');
                worksheet.mergeCells('B5:G5');
                worksheet.mergeCells('B6:G6');
                worksheet.mergeCells('I3:P3');
                worksheet.mergeCells('I4:P4');
                worksheet.mergeCells('I5:P5');
                worksheet.mergeCells('I6:P6');
            }
            /*worksheet.mergeCells(`B${4+mpCount} : G${4+mpCount}`);
            worksheet.mergeCells('G4:K4');
            worksheet.mergeCells(`B${5+mpCount} : G${5+mpCount}`);
            worksheet.mergeCells('G5:K5');
            worksheet.mergeCells(`B${6+mpCount} : G${6+mpCount}`);
            worksheet.mergeCells(`I${6+mpCount} : P${6+mpCount}`);*/
            worksheet.mergeCells(`A${8 + 3 * Math.max(0, mpCount1 - 1)} : P${8 + 3 * Math.max(0, mpCount1 - 1)}`);
            //merge rows
            // start_row+(n−1)×count
            if (mpCount1 != 0) {
                for (let i = 1; i < 5; i++) {
                    let startRow = getNextRow(3, mpCount1, i);
                    if (i == 4) {
                        worksheet.mergeCells(`B${startRow} : G${startRow}`);
                    }
                    else {
                        worksheet.mergeCells(`A${startRow} : A${startRow + (mpCount1 - 1)}`);
                        worksheet.mergeCells(`H${startRow} : H${startRow + (mpCount1 - 1)}`);
                        worksheet.mergeCells(`B${startRow} : G${startRow + (mpCount1 - 1)}`);
                    }
                }
            }
        }
        // Apply bold font for the above data
        for (let i = 3; i < 7; i++) {
            const rowData = worksheet.getRow(i);
            rowData.font = { bold: true };
        }
        // Set cell values for More Information section
        const headerRow = worksheet.getRow(9 + 3 * Math.max(0, mpCount1 - 1));
        headerRow.values = [
            BVConstants.ProjectDetailsExcelTemplate.Service_Name,
            BVConstants.ProjectDetailsExcelTemplate.Country,
            'Sub Project Status',
            'Risk Status',
            'Risk Status Reason',
            'Recommended Decision Date',
            'Recommended Start Date',
            'Actual Start Date',
            'Deadline',
            'Actual Completion Date',
            BVConstants.ProjectDetailsExcelTemplate.Remarks,
            'Action For Client',
            'Certificate ID',
            'Certificate Issue Date',
            'Certificate Expiration Date',
            'Certificate Status'
        ];
        (_1 = (_0 = Props.objMaster) === null || _0 === void 0 ? void 0 : _0.lstWorkOrder) === null || _1 === void 0 ? void 0 : _1.forEach((workOrder, index) => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            const rowNumber = index + (10 + 3 * Math.max(0, mpCount1 - 1));
            const dataRow = worksheet.getRow(rowNumber);
            const riskReasonCommentAppended = mapRiskCommentsWO.get(workOrder === null || workOrder === void 0 ? void 0 : workOrder.strWorkOrderId);
            if ((workOrder === null || workOrder === void 0 ? void 0 : workOrder.intRiskStatus) !== 1) {
            }
            dataRow.values = [
                (_a = workOrder === null || workOrder === void 0 ? void 0 : workOrder.objTblService) === null || _a === void 0 ? void 0 : _a.strServiceName,
                (_c = (_b = workOrder === null || workOrder === void 0 ? void 0 : workOrder.objTblService) === null || _b === void 0 ? void 0 : _b.objLuCountry) === null || _c === void 0 ? void 0 : _c.strLongDesc,
                (_d = workOrder === null || workOrder === void 0 ? void 0 : workOrder.objLuWorkOrderStatus) === null || _d === void 0 ? void 0 : _d.strLongDesc,
                (workOrder === null || workOrder === void 0 ? void 0 : workOrder.intRiskStatus) === 1 ? "Project on Schedule" : "Project on Risk",
                riskReasonCommentAppended,
                formatDateForExcel(workOrder === null || workOrder === void 0 ? void 0 : workOrder.dtReccomDecisionDate),
                formatDateForExcel(workOrder === null || workOrder === void 0 ? void 0 : workOrder.dtPlannedStartDate),
                formatDateForExcel(workOrder === null || workOrder === void 0 ? void 0 : workOrder.dtStartDate),
                formatDateForExcel(workOrder === null || workOrder === void 0 ? void 0 : workOrder.dtEstimatedComplDate),
                formatDateForExcel(workOrder === null || workOrder === void 0 ? void 0 : workOrder.dtCompletionDate),
                (_e = workOrder === null || workOrder === void 0 ? void 0 : workOrder.objTblService) === null || _e === void 0 ? void 0 : _e.strExternalRemarks,
                workOrder === null || workOrder === void 0 ? void 0 : workOrder.strActionForClients,
                (_f = workOrder === null || workOrder === void 0 ? void 0 : workOrder.objCert) === null || _f === void 0 ? void 0 : _f.strCertId,
                formatDateForExcel((_g = workOrder === null || workOrder === void 0 ? void 0 : workOrder.objCert) === null || _g === void 0 ? void 0 : _g.dtCertDate),
                formatDateForExcel((_h = workOrder === null || workOrder === void 0 ? void 0 : workOrder.objCert) === null || _h === void 0 ? void 0 : _h.dtCertExpirationDate),
                (_k = (_j = workOrder === null || workOrder === void 0 ? void 0 : workOrder.objCert) === null || _j === void 0 ? void 0 : _j.objCertStatus) === null || _k === void 0 ? void 0 : _k.strLongDesc,
            ];
            if (isRenewal) {
                dataRow.splice(7, 0, formatDateForExcel(workOrder === null || workOrder === void 0 ? void 0 : workOrder.dtActualDecisionDate));
                dataRow.splice(11, 0, formatDateForExcel(workOrder === null || workOrder === void 0 ? void 0 : workOrder.dtPrevCertDate));
                worksheet.getCell(`M${rowNumber}`).alignment = { wrapText: true };
            }
            else {
                worksheet.getCell(`K${rowNumber}`).alignment = { wrapText: true };
            }
            //assigning borders to the cells including empty cells
            // Define the cell range from A1 to H1
            const startCell = `A${rowNumber}`;
            const endCell = isRenewal ? `R${rowNumber}` : `P${rowNumber}`;
            // Loop through the cells in the range and set the border
            for (let col = startCell.charCodeAt(0); col <= endCell.charCodeAt(0); col++) {
                const cellReference = String.fromCharCode(col) + rowNumber; // Generate cell reference like A1, B1, C1, ...
                const cell = worksheet.getCell(cellReference);
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
            }
        }));
        if (isRenewal) {
            headerRow.splice(7, 0, 'Actual Decision Date');
            headerRow.splice(11, 0, 'Previous Certificate Experation Date');
            //dataRow.splice(7,0,'01/01/1997');
            //dataRow.splice(11,0,'10/12/2000');
            //worksheet.getCell('M10').alignment={wrapText: true};
        }
        else {
            //worksheet.getCell('K10').alignment={wrapText: true};
        }
        // Apply styles to the header row
        headerRow.font = { bold: true };
        headerRow.alignment = { horizontal: 'left', vertical: 'middle' };
        /*
            worksheet.columns.forEach((column) => {
              column.width = 12; // Adjust the width as needed
            });*/
        // Apply thin borders to all cells
        worksheet.eachRow((row) => {
            row.eachCell((cell) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
            });
        });
        // Style the header row
        // Apply silver background color to the first 12 cells of the header row
        applyStylesToHeader(1, 11, '808080', worksheet);
        applyStylesToHeader(2, 11, 'C0C0C0', worksheet);
        applyStylesToHeader(8 + 3 * Math.max(0, mpCount1 - 1), 11, 'C0C0C0', worksheet);
        if (Props.objMaster.lstDocuments) {
            createDocumentListSheet(workbook, (_2 = Props === null || Props === void 0 ? void 0 : Props.objMaster) === null || _2 === void 0 ? void 0 : _2.lstDocuments);
        }
        commonService
            .logUserActivity((_4 = (_3 = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _3 === void 0 ? void 0 : _3.userLoginDetails) === null || _4 === void 0 ? void 0 : _4.strUserEmailId, UserActivity.CP__ProjectDetails_Report_Download);
        // Generate the Excel file
        const buffer = yield workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        //
        const url = window.URL.createObjectURL(blob);
        // Create a download link and trigger a click event to download the file
        const a = document.createElement('a');
        a.href = url;
        a.download = isRenewal ? `RenewalProjectDetails${projectId}.xlsx` : `NewProjectDetails${projectId}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
    });
    return (_jsx(Button, { type: "primary", onClick: generateExcel, children: "Generate Project Report" }));
};
function createDocumentListSheet(workbook, lstDocuments) {
    const docListSheet = workbook.addWorksheet('Document List');
    const headerStyle = {
        fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'D9D9D9' },
        },
        font: { bold: true },
        border: {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        },
    };
    const boldTextStyle = {
        font: { bold: true },
        alignment: { wrapText: true },
        border: {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        },
    };
    const styleFltValue = {
        numFmt: '0.00',
        alignment: { horizontal: 'left', vertical: 'left' },
        border: {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        },
    };
    const style = {
        alignment: { wrapText: true },
        border: {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        },
    };
    // Create header row
    const headers = ["Document Category", "Document Type", "Generic/ Specific", "Service Type", "Country"];
    const headerRow = docListSheet.addRow(headers);
    headerRow.eachCell((cell) => {
        cell.style = headerStyle;
    });
    docListSheet.columns = [
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
    ];
    // Deep clone documents
    if (lstDocuments != null && lstDocuments.length > 0) {
        const clonedDocs = JSON.parse(JSON.stringify(lstDocuments));
        const separatedDiffServTypeDoc = [];
        // Process documents
        clonedDocs.forEach((doc) => {
            if (doc.strServiceTypes) {
                const serviceTypes = doc.strServiceTypes.split(", ");
                doc.strServiceTypes = serviceTypes[0];
                serviceTypes.slice(1).forEach((type) => {
                    separatedDiffServTypeDoc.push(Object.assign(Object.assign({}, doc), { strServiceTypes: type }));
                });
            }
        });
        clonedDocs.push(...separatedDiffServTypeDoc);
        // Fill data rows
        clonedDocs.forEach((doc) => {
            var _a, _b, _c;
            const rowData = [
                ((_a = doc.objLuDocumentCategory) === null || _a === void 0 ? void 0 : _a.strLongDesc) || '',
                ((_b = doc.objDocumentType) === null || _b === void 0 ? void 0 : _b.strLongDesc) || '',
                doc.boolIsGeneralDoc ? 'Generic' : 'Specific',
                doc.boolIsGeneralDoc ? '' : (doc.strServiceTypes || ''),
                doc.boolIsGeneralDoc ? '' : (((_c = doc.objLuCountry) === null || _c === void 0 ? void 0 : _c.strLongDesc) || ''),
            ];
            const dataRow = docListSheet.addRow(rowData);
            dataRow.eachCell((cell) => {
                cell.style = style;
            });
        });
    }
}
export default GenerateExcelReport;
